import type { ReactNode } from "react";
import { useProvider } from "./useProvider";
import type { ProviderFeatures } from "./types";

export const FEATURE_LABEL: Record<keyof ProviderFeatures, string> = {
  docx: "Word (.docx) dışa aktarma", dxf: "DXF dışa aktarma", polygonMode: "Serbest çokgen geometri", multiLayer: "Çok tabakalı dolgu",
  lineLoads: "Şerit / çizgisel yükler", jointChecks: "İç kesit (derz) kontrolleri", classicTable: "Klasik güvenlik katsayısı tablosu",
};
export const FEATURE_OFF_TITLE = "Bu özellik bu sürümde kapalı";

export function useFeature(key: keyof ProviderFeatures): boolean { return useProvider((s) => s.settings.features[key]); }

/** Kapalı özellik: içerik gri ve etkileşimsiz, ipucu metni. Motor yine tam çalışır. */
export function FeatureGate({ feature, children, inline = false }: { feature: keyof ProviderFeatures; children: ReactNode; inline?: boolean }): JSX.Element {
  const on = useFeature(feature);
  if (on) return <>{children}</>;
  const Tag = inline ? "span" : "div";
  return <Tag aria-disabled="true" title={FEATURE_OFF_TITLE} className="opacity-50 pointer-events-none select-none" data-feature-off={feature}>{children}</Tag>;
}
